import React, { useEffect, useState } from 'react'
import st from './ActionCard.module.scss'
import swal from 'sweetalert'
import Buttons from '../Buttons/Buttons'
import MergingCard from '../MergingCard/MergingCard'
import DeleteCard from '../DeleteCard/DeleteCard'
import InformationCard from '../InformationCard/InformationCard'
import { superAxiosRequest } from 'axiosApi'
import useLocalization from 'hooks/useLocalization'

const ActionCard = ({
  selectedTab,
  onTabChange,
  clickedCards,
  duplicate,
  setClickedCards,
  setDuplicates,
  duplicates,
  fetchDuplicates,
}) => {
  const initCheckedState = {
    name: null,
    deal_name: null,
    created_at: null,
    phone: null,
    manager: null,
    branch: null,
    budget: null,
    city: null,
    program: null,
    level: null,
    status_deal: null,
  }

  const initSelectedData = {
    name: '',
    deal_name: '',
    created_at: '',
    phone: '',
    manager: {
      id: null,
      full_name: '',
    },
    budget: '',
    branch: {
      id: null,
      full_name: '',
    },
    city: {
      id: null,
      name: '',
    },
    program: {
      id: null,
      name: '',
    },
    level: {
      id: null,
      name: '',
    },
    status_deal: {
      id: null,
      name: '',
    },
    funnels: [
      {
        id: null,
      },
    ],
  }

  const [checkedStates, setCheckedStates] = useState(initCheckedState)
  const [selectedData, setSelectedData] = useState(initSelectedData)
  const [clickedId, setClickedId] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      information: 'Information',
      delete: 'Delete',
      merging: 'Merge',
      mergingRu: 'Merge',
    },
  })

  useEffect(() => {
    setClickedId(null)
    setSelectedUser(null)
    setSelectedData(initSelectedData)
    setCheckedStates(initCheckedState)
  }, [selectedTab])

  const actions = {
    merging: {
      label: translate?.mergingRu,
      style: st.container,
      body: (
        <MergingCard
          clickedCards={clickedCards}
          duplicate={duplicate}
          checkedStates={checkedStates}
          setCheckedStates={setCheckedStates}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      ),
      onSave: () => {
        const cardNewId = [
          ...clickedCards
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((obj) => obj.id),
        ][0]
        const cardNew = clickedCards.find((obj) => obj.id === cardNewId)
        superAxiosRequest(
          {
            method: 'put',
            link: `integration/deals/${cardNewId}`,
            crm: true,
          },
          {
            deal_name: selectedData?.deal_name,
            manager: selectedData.manager?.id,
            client: selectedData.client?.id,
            budget: selectedData.budget,
            city: selectedData.city?.id,
            branch: selectedData.branch?.id,
            program: selectedData.program?.id,
            level: selectedData.level?.id,
            status_deal: selectedData.status_deal?.id,
            funnels: cardNew.funnels?.map((obj) => obj.id),
          },
        ).then(() => {
          superAxiosRequest(
            {
              method: 'post',
              link: `integration/cascade_replace_deals`,
              crm: true,
            },
            {
              first_deal: clickedCards.find((card) => card.id !== cardNewId).id,
              second_deal: cardNewId,
            },
          ).then(() => {
            setClickedCards([])
            setDuplicates((prevData) =>
              prevData.map((data) =>
                duplicate.id === data.id
                  ? {
                      ...data,
                      deals: data.deals.filter((deal) => deal.id !== clickedId),
                    }
                  : data,
              ),
            )
            fetchDuplicates()
          })
        })
      },
    },
    delete: {
      label: translate?.delete,
      style: st.containerDelete,
      body: (
        <DeleteCard
          clickedCards={clickedCards}
          duplicate={duplicate}
          clickedId={clickedId}
          setClickedId={setClickedId}
        />
      ),
      onSave: () => {
        swal({
          title: 'Are you sure?',
          text: 'Do you want to delete this duplicate?',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((willProceed) => {
          if (willProceed) {
            superAxiosRequest(
              {
                method: 'post',
                link: `integration/cascade_replace_deals`,
                crm: true,
              },
              {
                first_deal: clickedId,
                second_deal: clickedCards.find((card) => card.id !== clickedId)
                  .id,
              },
            )
              .then(() => {
                setClickedCards([])
                setDuplicates((prevData) =>
                  prevData.map((data) =>
                    duplicate.id === data.id
                      ? {
                          ...data,
                          deals: data.deals.filter(
                            (deal) => deal.id !== clickedId,
                          ),
                        }
                      : data,
                  ),
                )
                fetchDuplicates()
                swal('Success!', 'Double was deleted.', 'success')
              })
              .catch(() => {
                swal(
                  'Error!',
                  'Something went wrong. Please try again.',
                  'error',
                )
              })
          }
        })
      },
    },
    dontMerge: {
      label: translate?.information,
      style: st.containerInformation,
      body: (
        <InformationCard
          clickedCards={clickedCards}
          setClickedCards={setClickedCards}
          duplicates={duplicates}
          duplicate={duplicate}
          clickedId={clickedId}
          setClickedId={setClickedId}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
        />
      ),
      onSave: () => {
        const cardNew = clickedCards.find((obj) => obj.id === clickedId)
        superAxiosRequest(
          {
            method: 'put',
            link: `integration/deals/${clickedId}`,
            crm: true,
          },
          {
            deal_name: cardNew?.deal_name,
            manager: cardNew?.manager?.id,
            client: selectedUser?.id,
            budget: cardNew?.budget,
            city: cardNew?.city?.id,
            branch: cardNew?.branch?.id,
            program: cardNew?.program?.id,
            level: cardNew?.level?.id,
            status_deal: cardNew.status_deal?.id,
            funnels: cardNew.funnels?.map((obj) => obj.id),
          },
        ).then(() => {
          setClickedCards([])
          setDuplicates((prevData) =>
            prevData.map((data) =>
              duplicate.id === data.id
                ? {
                    ...data,
                    deals: data.deals.filter((deal) => deal.id !== clickedId),
                  }
                : data,
            ),
          )
          fetchDuplicates()
        })
      },
    },
  }

  return (
    <div className={`${actions[selectedTab].style}`}>
      <div className={st.secondContainer}>
        <Buttons
          actions={actions}
          onTabChange={onTabChange}
          selectedTab={selectedTab}
          checkedStates={checkedStates}
          selectedUser={selectedUser}
          clickedId={clickedId}
        />
        <div className={st.line}></div>
        <div>{actions[selectedTab].body}</div>
      </div>
    </div>
  )
}

export default ActionCard
